import { Box, Typography, Button } from "@mui/material"
import { Logo } from "../../../../../../core/global/Icons"
export const Header = ({regHandler}) =>{

    return(
        <Box sx={{display: "flex",p: 2, width: "100%"}}>
            <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center", width: '100%'}}>
                <Box sx={{display: "flex", gap: 1,}}>
                    <Logo size={24}/>
                    <Typography sx={{fontWeight: 600, color: "#fff", }}>POS</Typography>
                </Box>
                <Box>
                    <Button onClick={regHandler} sx={{display: "flex", gap: 2, px: 2, bgcolor:'#c0ffd0ff', ':hover': {bgcolor: "#c0ffd0ff"}, alignItems: "center", borderRadius: 8}}>
                        <Box sx={{fontWeight: 400, color: "primary.main"}}>
                            Avail <strong> NOW </strong>while It's <strong>FREE!</strong>
                        </Box>
                    </Button>
                </Box>
            </Box>
        </Box>
    )
}